export default __webpack_public_path__ + "static/media/crates3.1bcf9331.png";